var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3846_19975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3846_19975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6633 15.4313L9.93828 10.725C9.56328 11.0375 9.13203 11.2812 8.64453 11.4562C8.15703 11.6312 7.65703 11.7188 7.14453 11.7188C5.85703 11.7188 4.76953 11.275 3.88203 10.3875C2.99453 9.5 2.55078 8.4125 2.55078 7.125C2.55078 5.85 2.99453 4.7655 3.88203 3.8715C4.76953 2.978 5.85703 2.53125 7.14453 2.53125C8.41953 2.53125 9.50078 2.975 10.3883 3.8625C11.2758 4.75 11.7195 5.8375 11.7195 7.125C11.7195 7.6625 11.632 8.175 11.457 8.6625C11.282 9.15 11.0445 9.575 10.7445 9.9375L15.4508 14.6437L14.6633 15.4313ZM7.14453 10.5938C8.10703 10.5938 8.92278 10.2562 9.59178 9.58125C10.2603 8.90625 10.5945 8.0875 10.5945 7.125C10.5945 6.1625 10.2603 5.34375 9.59178 4.66875C8.92278 3.99375 8.10703 3.65625 7.14453 3.65625C6.16953 3.65625 5.34778 3.99375 4.67928 4.66875C4.01028 5.34375 3.67578 6.1625 3.67578 7.125C3.67578 8.0875 4.01028 8.90625 4.67928 9.58125C5.34778 10.2562 6.16953 10.5938 7.14453 10.5938Z",
    fill: "#67748E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.910de7c59b591d6fb203276827dadc7f.svg";
export { ForwardRef as ReactComponent };